mutation CreateView (
    $videoId: ID!
) {
    createView (
        video_id: $videoId
    ) {
        status
        message
    }
}
